import { mediator } from '@ioc/mediator'
import { RequestData } from 'mediatr-ts'

export class AbstractGeneratorCommand extends RequestData<string | undefined> {
  constructor(public readonly text: string) {
    super()
  }
}

export const generateAbstract = (text: string) =>
  mediator.send<string | undefined>(new AbstractGeneratorCommand(text))
